import React from 'react';
import AdminShell from '../components/AdminShell';
import { API_BASE } from '../lib/api';
import { Download } from 'lucide-react';

const datasets = [
  { k: 'households', label: 'Households (parents/guardians)' },
  { k: 'learners', label: 'Learners' },
  { k: 'enrolments', label: 'Enrolments (per year)' },
  { k: 'subject_subscriptions', label: 'Subject subscriptions' },
  { k: 'registrations', label: 'Registrations' },
  { k: 'invoices', label: 'Invoices' },
  { k: 'payments', label: 'Payments' },
  { k: 'onboarding', label: 'Onboarding records' },
  { k: 'audit_logs', label: 'Audit logs' },
];

const AdminReports = () => (
  <AdminShell title="Reports & exports">
    <p className="text-sm text-[#4B5563] mb-4">Bulk exports are Owner-only and are recorded in the audit log.</p>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="exports-grid">
      {datasets.map((d) => (
        <a
          key={d.k}
          href={`${API_BASE}/admin/exports/${d.k}.csv`}
          className="bg-white rounded-2xl border border-black/5 p-5 hover:border-[#1F6F4A] transition-all flex items-center justify-between"
          data-testid={`export-${d.k}`}
        >
          <span className="text-sm font-medium text-[#1B2A41]">{d.label}</span>
          <Download size={16} className="text-[#1F6F4A]"/>
        </a>
      ))}
    </div>
  </AdminShell>
);

export default AdminReports;
